import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}/utils`
const testUrl = localStorage.getItem(TEST_URl)
const testBaseUrl = `${testUrl}/utils`
const baseUrl = testUrl ? testBaseUrl : defaultBaseUrl

export async function uploadFileService (payload) {
  const res = await axios.post(
    `${baseUrl}/upload-files?type=${payload.type}`,
    payload.data,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return res
}
